import classNames from "classnames";
import classes from "./SpeechBubble.module.less";
import { type ReactNode } from "react";

type Position = "left" | "right" | "top" | "bottom";
interface Props {
  className?: string;
  tailPosition?: Position;
  children?: ReactNode;
}

const TAIL_CLASSES: Record<Position, string> = {
  left: classes.tailLeft,
  right: classes.tailRight,
  top: classes.tailTop,
  bottom: classes.tailBottom,
};

export const SpeechBubble = ({ className, tailPosition = "top", children }: Props) => {
  return (
    <div className={classNames(classes.root, className, TAIL_CLASSES[tailPosition])}>
      <div className={classes.bubble}>{children}</div>
    </div>
  );
};
